import { gsap, ScrollTrigger } from './gsap';

const readmore = () => {
  const container = document.querySelector('.partnerships-overview');

  if (container) {
    const expand = (article, btn, articleTitle, articleImg, articleContent, articleContentChildren) => gsap.timeline({
      paused: true,
      reversed: true,
      ease: 'power1',
      onComplete: () => {
        ScrollTrigger.refresh();
      },
      onReverseComplete: () => {
        ScrollTrigger.refresh();
      }
    })
      .to(btn, {
        duration: 0.2,
        x: 20,
        autoAlpha: 0
      })
      .to(articleTitle, {
        duration: 0.4,
        y: 30,
        autoAlpha: 0,
        onComplete: () => {
          article.classList.add('open');
        },
      })
      .to(articleImg, {
        duration: 0.2,
        height: 'auto',
        position: 'relative',
        '--overlay-opacity': 0,
        onReverseComplete: () => {
          gsap.set(articleImg, { height: '100%' });
        }
      }, '>')
      .to(articleContent, {
        duration: 0.2,
        autoAlpha: 1,
        display: 'block',
        height: 'auto',
        onReverseComplete: () => {
          article.classList.remove('open');
        }
      }, '<')
      .to(articleTitle, {
        duration: 0.4,
        y: 0,
        autoAlpha: 1,
      }, '>')
      .from(articleContentChildren, {
        duration: 0.4,
        y: 20,
        autoAlpha: 0,
      }, '<');

    const articles = document.querySelectorAll('.partnerships-overview article');

    articles.forEach((article) => {
      const readMore = article.querySelector('.read-more');
      const readMoreBtn = article.querySelector('.read-more .btn');
      const title = article.querySelector('.grid-item__title');
      const thumbnail = article.querySelector('.grid-item__img');
      const hiddenContent = article.querySelector('.grid-item__content-hidden');
      const hiddenContentChildren = article.querySelectorAll('.grid-item__content-hidden > *');

      const articleTimeline = expand(article, readMoreBtn, title, thumbnail, hiddenContent, hiddenContentChildren);

      readMore.addEventListener('click', (e) => {
        e.preventDefault();

        const isOpen = article.classList.contains('open');
        if (!isOpen) {
          articleTimeline.play();
        } else {
          articleTimeline.reverse();
        }
      });
    });
  }
};

export default readmore;
